<template>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 mr-r10 vertical-center-box">대상 목록</div>
        <span v-show="selectedAgentManagerGroupId === 0 && type === 'agentGroup'" style="line-height: 16px;" >기본 에이전트 그룹의 관리대상은 해제할 수 없습니다.</span>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" :disabled="checkedRows.length === 0" @click="onClickReleaseButton">해제</el-button>
        <el-button class="mr-r4" :disabled="!changeCheckedObjListFlag" @click="onClickSaveButton">저장</el-button>
        <el-button class="mr-r4" :disabled="!changeCheckedObjListFlag" @click="onClickCancelButton">취소</el-button>
        <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper :data="checkedObjList" :columns="tableColumns" :column-default="columnDefault" ref="selectedObjTable" remote pagination :total="total"
        :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeCheckedRow" @condition-change="onConditionChange">
        <template #readonly-checkbox-slot="scope">
          <el-checkbox :value="scope.row.staticFlag" true-label="1" false-label="0" class="checkbox-agent-static-flag" style="cursor: default !important;" />
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { isEqual, difference, cloneDeep } from 'lodash';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import AgentSettingsAPI from '@/api/settings/common/agent-settings';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WAgentSelectedObjTable',
  props: {
    type: String,
    checkedObjList: Array,
    originCheckedObjIds: Array,
    selectedAgentManagerGroupId: Number,
    selectedAgentManagerId: Number,
    total: {
      type: Number,
      default: 0,
    },
    activeTab: String,
  },
  watch: {
    checkedObjList() {
      this.checkChangeCheckedObjList();
    },
    activeTab: {
      handler() {
        this.tableColumns = [];
        this.$nextTick(() => {
          const columns = cloneDeep(this.commonColumns);
          const agentGroupColumnsIdx = 3; // 수집서버 그룹 설정 탭에만 추가할 컬럼 위치 인덱스
          if (this.activeTab === 'WAgentGroup') { // 수집서버 그룹 설정 탭에만 추가
            columns.splice(agentGroupColumnsIdx, 0, ...cloneDeep(this.agentGroupColumns));
          }
          this.tableColumns = cloneDeep(columns);
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      checkedObjIds: [],
      changeCheckedObjListFlag: false,
      columnDefault,
      showSearchTool: false,
      checkedRows: [],
      tableColumns: [],
      commonColumns: [
        {
          type: 'selection',
          width: 55,
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          width: 100,
          searchable: true,
          remoteProp: 'm.managetype_name',
          formatter: defaultFormatter,
          sortable: true,
        },
        {
          prop: 'objName',
          label: '대상명',
          searchable: true,
          remoteProp: 'o.obj_name',
          formatter: defaultFormatter,
          sortable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          searchable: true,
          formatter: defaultFormatter,
          sortable: true,
        },
      ],
      agentGroupColumns: [
        {
          prop: 'agentManagerName',
          label: '수집서버명',
          remoteProp: 'amamoi.agent_manager_name',
          searchable: true,
          sortable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'staticFlag',
          label: '고정여부',
          scopedSlot: 'readonly-checkbox-slot',
          width: 55,
          align: 'center',
        },
      ],
    };
  },
  computed: {
    getPagingParams() {
      return this.$refs.selectedObjTable.getParameter();
    },
  },
  methods: {
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    onClickReleaseButton() {
      this.checkedRows.forEach((row) => {
        this.checkedObjList.splice(this.checkedObjList.indexOf(row), 1);
      });
      this.$emit('reload-obj-list');
    },
    onClickSaveButton() {
      const insertObjIds = difference(this.checkedObjIds, this.originCheckedObjIds);
      const deleteObjIds = difference(this.originCheckedObjIds, this.checkedObjIds);
      const objList = [];
      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      if (isEqual(this.type, 'agentGroup')) {
        insertObjIds.forEach((objId) => {
          objList.push({
            objId,
            agentManagerGroupId: this.selectedAgentManagerGroupId,
          });
        });
        if (this.selectedAgentManagerGroupId > 0) {
          deleteObjIds.forEach((objId) => {
            objList.push({
              objId,
              agentManagerGroupId: 0,
            });
          });
        }
        AgentSettingsAPI.updateObjectOfAgentGroup(objList).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      } else {
        insertObjIds.forEach((objId) => {
          objList.push({
            objId,
            agentManagerId: this.selectedAgentManagerId,
            sql_type: 'INSERT',
          });
        });
        deleteObjIds.forEach((objId) => {
          objList.push({
            objId,
            agentManagerId: this.selectedAgentManagerId,
            sql_type: 'DELETE',
          });
        });
        AgentSettingsAPI.updateObjectOfAgentManager(objList).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    onClickCancelButton() {
      this.$emit('load-data');
    },
    checkChangeCheckedObjList() {
      const checkedObjIds = [];
      this.checkedObjList.forEach((obj) => {
        if (!checkedObjIds.includes(obj.objId)) {
          checkedObjIds.push(obj.objId);
        }
      });
      checkedObjIds.sort((a, b) => (a - b));
      this.checkedObjIds = checkedObjIds;
      this.changeCheckedObjListFlag = !isEqual(checkedObjIds, this.originCheckedObjIds);
    },
    // getPagingParams() {
    //   return this.$refs.selectedObjTable.getParameter();
    // },
    onConditionChange() {
      this.$emit('load-data', true);
    },
    onAgentTableClearFilter() {
      this.showSearchTool = false;
      this.$refs.selectedObjTable.clearFilter();
    },
  },
};
</script>

<style>
.checkbox-agent-static-flag .el-checkbox__input {
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/components/AgentSelectedObjTable.vue